import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type ActivityTimeStopData = {
  timeManagementUuid: string;
};

const usePutActivityTimeStop = (
  options?: UseMutationOptions<any, Error, ActivityTimeStopData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['stopActivityTime'],
    mutationFn: async (data: ActivityTimeStopData) => {
      return axiosInstance.put(`/activity/time-stop`, data).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Zatrzymywanie liczenia czasu dla aktywności...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'stop-activity-time',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Czas dla aktywności zatrzymany pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'stop-activity-time',
      });
      queryClient.invalidateQueries({ queryKey: ['timeManagement'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas zatrzymywania mierzenia czasu dla aktywności.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'stop-activity-time',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePutActivityTimeStop;
